module.exports = __webpack_public_path__ + "880750da868b36b4ee778fd5984c65b5.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/css/fonts/itcavantgardestd-bk-webfont.svg
 ** module id = 373
 ** module chunks = 0
 **/